(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/ticket-with-podium-shadow.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/ticket-with-podium-shadow.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  useRef = _React.useRef;

const SHADOW_METRICS = {
  colorRgb: '108, 83, 13'
};
const SHADOW_DEFAULTS = {
  width: '40%',
  blurPx: 1.7,
  aspectRatio: '8 / 1'
};
const DEFAULT_FRAME_METRICS = {
  visualWidth: 0,
  visualHeight: 0,
  offsetX: 0,
  offsetY: 0,
  projectedShadowWidth: 0,
  objectPosition: 'center bottom'
};
const DEFAULT_SHADOW_STATE = {
  aspectRatio: 1
};

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
const getNormalizedAspectRatio = aspectRatio => {
  if (typeof aspectRatio === 'number' && Number.isFinite(aspectRatio) && aspectRatio > 0) {
    return aspectRatio;
  }
  return 1;
};
const getShadowWidthPercent = aspectRatio => {
  const normalizedRatio = getNormalizedAspectRatio(aspectRatio);
  if (normalizedRatio >= 1) {
    return 140;
  }

  const portraitNarrowness = clamp(1 - normalizedRatio, 0, 0.7);
  return 90 - portraitNarrowness * 30;
};

const getFrameMetrics = () => DEFAULT_FRAME_METRICS;
const getShadowState = function () {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    aspectRatio = _ref.aspectRatio;
  return {
    aspectRatio: getNormalizedAspectRatio(aspectRatio)
  };
};

const getShadowBackground = () => "radial-gradient(ellipse at center,\n  rgba(".concat(SHADOW_METRICS.colorRgb, ", 0.96) 0%,\n  rgba(").concat(SHADOW_METRICS.colorRgb, ", 0.84) 26%,\n  rgba(").concat(SHADOW_METRICS.colorRgb, ", 0.56) 48%,\n  rgba(").concat(SHADOW_METRICS.colorRgb, ", 0) 76%)");
const getPodiumPlatformBaseStyle = () => ({
  aspectRatio: '819 / 147',
  backgroundImage: "url(\"".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets/next-gen/podium-shadowed-small.png\")"),
  backgroundSize: 'contain',
  backgroundPosition: 'center bottom',
  backgroundRepeat: 'no-repeat',
  pointerEvents: 'none',
  display: 'flex'
});

const useTicketWithPodiumShadow = () => {
  const stageRef = useRef(null);
  const panelRef = useRef(null);
  const configuredLiftPx = 0;
  const reservedLiftPx = 0;
  const frameMetrics = DEFAULT_FRAME_METRICS;
  const panelMetrics = {
    width: 0,
    height: 0
  };
  const surfaceWidth = 0;
  const surfaceHeight = 0;
  const shadowState = getShadowState();
  return {
    stageRef,
    panelRef,
    shadowState,
    configuredLiftPx,
    reservedLiftPx,
    frameMetrics,
    surfaceWidth,
    surfaceHeight,
    panelMetrics
  };
};

const TicketWithPodiumShadow = React.memo(_ref2 => {
  let _ref2$shadowState = _ref2.shadowState,
    shadowState = _ref2$shadowState === void 0 ? DEFAULT_SHADOW_STATE : _ref2$shadowState,
    aspectRatio = _ref2.aspectRatio,
    _ref2$opacity = _ref2.opacity,
    opacity = _ref2$opacity === void 0 ? 1 : _ref2$opacity,
    _ref2$translateY = _ref2.translateY,
    translateY = _ref2$translateY === void 0 ? '0%' : _ref2$translateY,
    _ref2$overrridStyle = _ref2.overrridStyle,
    overrridStyle = _ref2$overrridStyle === void 0 ? {} : _ref2$overrridStyle,
    _ref2$centered = _ref2.centered,
    centered = _ref2$centered === void 0 ? false : _ref2$centered;
  const safeOpacity = clamp(opacity, 0, 1);
  const safeShadowState = _objectSpread(_objectSpread({}, DEFAULT_SHADOW_STATE), shadowState);
  const resolvedAspectRatio = getNormalizedAspectRatio(aspectRatio || safeShadowState.aspectRatio);
  const shadowWidth = "".concat(getShadowWidthPercent(resolvedAspectRatio), "%");
  const platformTransform = centered ? "translate(-50%, ".concat(translateY, ")") : "translateY(".concat(translateY, ")");
  return React.createElement("div", {
    style: _objectSpread(_objectSpread(_objectSpread({}, getPodiumPlatformBaseStyle()), overrridStyle), {}, {
      transform: platformTransform
    })
  }, React.createElement("div", {
    className: "ticket-podium-shadow"
  }, React.createElement("div", {
    className: "ticket-podium-shadow__shadow",
    style: {
      left: '50%',
      top: '45%',
      width: shadowWidth,
      height: '22%',
      transform: 'translate(-50%, -25%)',
      background: getShadowBackground(),
      filter: "blur(".concat(SHADOW_DEFAULTS.blurPx, "px)"),
      opacity: safeOpacity
    }
  })));
});

setGlobal('svs.tickets.next.components.ticketWithPodiumShadow', {
  DEFAULT_SHADOW_STATE,
  DEFAULT_FRAME_METRICS,
  getFrameMetrics,
  getShadowState,
  getPodiumPlatformBaseStyle,
  useTicketWithPodiumShadow
});
setGlobal('svs.tickets.next.components.TicketWithPodiumShadow', TicketWithPodiumShadow);

 })(window);